import Api from 'api';
import Button from 'atoms/Button';
import Modal from 'atoms/Modal';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store';
import { closeModal } from 'store/layoutSlice';

type DeleteAutomationModalProps = {
    automationId?: string;
    automationName?: string;
};

export const DeleteAutomationModal = ({
    automationId,
    automationName,
}: DeleteAutomationModalProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const [isDeleting, setIsDeleting] = useState(false);

    const handleClose = () => {
        dispatch(closeModal({ name: 'deleteAutomation' }));
    };

    const handleConfirm = () => {
        if (!automationId) return;

        setIsDeleting(true);
        Api.defaultApi()
            .deleteAutomation(automationId)
            .then(() => {
                window.dispatchEvent(
                    new CustomEvent('automationDeleted', {
                        detail: { id: automationId },
                    })
                );
                handleClose();
            })
            .catch(() => {
                setIsDeleting(false);
            });
    };

    return (
        <Modal size="s" open={true} onClose={handleClose}>
            <header>
                <h2>Delete Automation</h2>
            </header>
            <main>
                <p style={{ marginBottom: '24px' }}>
                    Are you sure you want to delete{' '}
                    <strong>'{automationName}'</strong>? This action cannot be
                    undone.
                </p>
            </main>
            <footer>
                <div />
                <div
                    style={{
                        display: 'flex',
                        gap: '8px',
                        justifyContent: 'center',
                    }}
                >
                    <Button size="m" theme="blank" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        size="m"
                        theme="primary"
                        onClick={handleConfirm}
                        loading={isDeleting}
                    >
                        Delete
                    </Button>
                </div>
            </footer>
        </Modal>
    );
};
